<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #5d7c9b !important; font-size: 14px"
    >
      <h6 class="title">
        {{ title ?? "Report Detail" }}
      </h6>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-12">
      <input type="file" (change)="onFileChange($event)" />
      <div [innerHTML]="excelHtml" class="excel-html-container"></div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-12">
      <iframe
        src="https://view.officeapps.live.com/op/embed.aspx?src=https://file-examples.com/storage/fe28b3ef8666c4c399639b9/2017/02/file_example_XLSX_5000.xlsx"
        width="100%"
        height="600px"
      ></iframe>
    </div>
  </div>
</main>
